import { Asset } from '@/shared/api/protocol-ts/model/dto_asset_pb';
import { AssetContent_Study_CBCT_CBCT_Metadata } from '@/shared/api/protocol-ts/model/dto_asset_study_pb';

export const getCBCTMetaData = (studyID: string) => (assets: Asset[]) => {
  const targetAsset = assets.find(
    (asset) =>
      asset.Kind.case === 'Study' && asset.Kind.value.StudyID === studyID,
  );

  const studyAsset =
    targetAsset?.Kind.case === 'Study' ? targetAsset.Kind.value : undefined;

  if (studyAsset?.Content.case === 'CBCT') {
    return studyAsset.Content.value.Metadata;
  }

  // CBCT_DCCT carries the same study metadata under a different shape — map
  // the DCCT-sanitized fields onto the CBCT_Metadata view so downstream UI
  // (study card, scan info) renders identically regardless of upload path.
  if (studyAsset?.Content.case === 'CBCTDCCT') {
    const dcctMeta = studyAsset.Content.value.Metadata;

    if (!dcctMeta) {
      return undefined;
    }

    return new AssetContent_Study_CBCT_CBCT_Metadata({
      StudyTime: dcctMeta.AcquisitionDateTime,
      ScanUID: dcctMeta.SeriesInstanceUID,
      Manufacturer: dcctMeta.Manufacturer,
      ManufacturerModelName: dcctMeta.ManufacturerModelName ?? '',
      VoxelSize: dcctMeta.PixelSpacing,
    });
  }

  return undefined;
};
